export default function FacebookIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <g clipPath="url(#clip0_21_1737)">
                <path d="M11.5463 20V10.8777H14.607L15.0662 7.32156H11.5463V5.05147C11.5463 4.0222 11.8309 3.32076 13.3085 3.32076L15.1901 3.31999V0.13923C14.8647 0.0969453 13.7478 0 12.4478 0C9.73317 0 7.87471 1.65697 7.87471 4.69927V7.32156H4.80469V10.8777H7.87471V20H11.5463Z" fill="#292D36" />
            </g>
            <defs>
                <clipPath id="clip0_21_1737">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}
